import global from './global/en.json';
import placeholders from './input/placeholders/en.json';
import errors from './input/errors/en.json';
import labels from './input/labels/en.json';
import notifications from './notifications/en.json';
import idle from './idle/en.json';
import start from './start/en.json';
import draw from './draw/en.json';
import invent from './invent/en.json';
import share from './share/en.json';
import share_link from './share-link/en.json';
import share_sms from './share-sms/en.json';
import share_email from './share-email/en.json';
import souvenir from './souvenir/en.json';
import drawing_ready from './drawing-ready/en.json';
import invention_ready from './invention-ready/en.json';
import page_not_found from './page-not-found/en.json';

export default {
  global,
  notifications,
  idle,
  start,
  draw,
  drawing_ready,
  invention_ready,
  invent,
  share,
  share_link,
  share_sms,
  share_email,
  souvenir,
  page_not_found,
  input: {
    labels,
    placeholders,
    errors
  }
};
